<template>
  <div>
    <v-data-table
      :items="gruops"
      :headers="gruopsHeader"
      class="elevation-1 rounded"
      :disable-pagination="true"
      :hide-default-footer="true"
      :no-data-text="tableText"
    >
    </v-data-table>
  </div>
</template>

<script>
import { getGroupInfo } from "@/api/user";
export default {
  data() {
    return {
      gruops: [],
      gruopsHeader: [
        {
          text: "نام گروه",
          value: "Name",
          width: "30%",
        },
        {
          text: "شروع",
          value: "StartDate",
          width: "10%",
        },
        {
          text: "پایان",
          value: "EndDate",
          width: "10%",
        },
        {
          text: "توضیحات",
          value: "Comment",
          width: "45%",
        },

        
      ],
    };
  },
  created() {
    this.getGroupInfo();
  },
  computed: {
    isMobile() {
      return this.$store.getters.isMobile;
    },
    tableText() {
      return this.$store.getters.tableText;
    },
  },
  methods: {
    getGroupInfo() {
      this.$store.commit("SET_TABLE_TEXT", true);
      return new Promise((resolve, reject) => {
        getGroupInfo()
          .then((response) => {
            if (!response.data) {
              reject("error");
            }
            this.gruops = response.data;

            this.$store.commit("SET_TABLE_TEXT", false);

            resolve(response);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
  },
};
</script>
<style scoped>
.grid {
  margin: 10px 0;
}
</style>
